import { api } from "assets/scripts/utilities/api-clients";

export const index = async (_id) => {
  const response = await api.get(`/kam/deal-submissions/${_id}`);

  return response;
};

export const get = async (_id) => {
  const response = await api.get(`/kam/deal/${_id}`);

  return response;
};

export const post = async (bid) => {
  const response = await api.post("/kam/deal-submission", bid);

  return response;
};

export const put = async (bid) => {
  const response = await api.put(`/kam/${bid._id}/update-deal-submission`, bid);

  return response;
};

export const putDealsToOrder = async (deal_id) => {
  const response = await api.put(`/kam/deals/${deal_id}/convert-to-order`);

  return response;
};
